import { Routes, Route, Navigate } from 'react-router-dom';
import Users from "./pages/User/Users";

import Pages from "./pages/Page/Pages";
import BannerGroups from "./pages/BannerGroup/BannerGroups";

import Posts from "./pages/Post/Posts";

import SeoRedirect from "./pages/SeoRedirect/SeoRedirect";
import Comment from "./pages/Comment/Comments";

import Profile from "./pages/Profile/Edit";
import Message from "./pages/Message/Edit";
import { useUser } from './Components/UserProvider';
import Courses from './pages/Courses/Courses';
import Languages from './pages/Language/Languages';
import Announcements from './pages/Announcement/Announcements';
import Categories from "./pages/Category/Categories";
import TeamMembers from "./pages/TeamMembers/TeamMembers";

export default function Router() {
    const user = useUser();
    
    return <Routes>
        { user.type === 512 && <Route path="/user/*" element={<Users />}/> }
        <Route path="/profile" element={<Profile />}/>
        <Route path="/message/*" element={<Message />}/>

        { user.type === 512 && <Route path="/category/*" element={<Categories />} /> }
        { user.type === 512 && <Route path="/page/*" element={<Pages />} /> }
        { user.type === 512 && <Route path="/post/*" element={<Posts />} /> }
        { user.type === 512 && <Route path="/course/*" element={<Courses />} /> }
        { user.type === 512 && <Route path="/language/*" element={<Languages />} /> }
        { user.type === 512 && <Route path="/announcement/*" element={<Announcements />} /> }
        { user.type === 512 && <Route path="/team-member/*" element={<TeamMembers />} /> }
        
        { user.type === 512 && <Route path="/banner-group/*" element={<BannerGroups />} /> }
        { user.type === 512 && <Route path="/seo-redirect/*" element={<SeoRedirect />} /> }
        { user.type === 512 && <Route path="/comment/*" element={<Comment />} /> }
        
        <Route path="*" element={<Navigate to="/profile" />} />
    </Routes>;
}


